<template>
  <v-container id="my-time" class="px-0 py-0" fluid v-if="isRegister">
    <v-toolbar id="calendar-toolbar" flat>
      <v-btn small outlined color="primary" @click="getToday()">Oggi</v-btn>
      <v-btn small icon color="primary" @click="$refs.myCalendar.prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <v-btn small icon color="primary" @click="$refs.myCalendar.next()"><v-icon dark>mdi-chevron-right</v-icon></v-btn>
      <span class="caption font-weight-medium primary--text">{{ formattedStart }} &mdash; {{ formattedEnd }}</span>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="primary" icon @click="generateReport()"><v-icon>mdi-printer</v-icon></v-btn>
        </template>
        <span>Stampa report</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }" class="mt-6">
          <v-btn small fab dark color="green" elevation="3" v-on="on" @click="createEvent()">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Registra nuova attività</span>
      </v-tooltip>
    </v-toolbar>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" class="px-0 py-0">
        <v-sheet :height="calendarHeight" v-resize="adaptCalendar">
          <v-calendar ref="myCalendar" v-model="current" color="secondary" :event-color="getEventColor" type="week" locale="it-it" style="width: 100%; border: 0;"
            :weekdays="weekInItaly" :events="events" @change="getEvents" @click:event="viewEvent" :event-overlap-mode="overlapMode"
            :first-interval="intervals.first" :interval-minutes="intervals.minutes" :interval-count="intervals.count" :interval-height="intervals.height" :short-intervals="false">
          </v-calendar>
            
          <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
            <v-card min-width="350px">
              <v-card-title class="headline">{{ selectedEvent.name }}</v-card-title>
              <v-card-subtitle>{{ formattedDayOfEvent }}</v-card-subtitle>
              <v-card-text>
                <div>{{ selectedEvent.area }}</div>
                <div class="text--primary">{{ selectedEvent.details }}</div>
                <div class="mt-2" v-if="selectedEvent.flagSmartWorking">
                  <v-chip color="green" label small text-color="white">
                    <v-icon left>mdi-check</v-icon>Smart Working
                  </v-chip>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn v-if="selectedEvent.editable" icon color="orange" @click="editEvent()"><v-icon>mdi-circle-edit-outline</v-icon></v-btn>
                <v-btn v-if="selectedEvent.removable" icon color="red" @click="askRemoveEvent()"><v-icon>mdi-delete</v-icon></v-btn>
                <v-spacer></v-spacer>
                <v-btn icon @click="selectedOpen = false"><v-icon>mdi-close</v-icon></v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>

    <event-form ref="refEventForm" :isNew="isNewEvent" :event="eventAsRequest" @saved="notify"></event-form>
    <report-form ref="refReportForm" :report="report"></report-form>
    <confirm ref="refConfirm" :item="selectedEvent" @confirmed="removeEvent"></confirm>
    <notify ref="refNotify"></notify>
  </v-container>
</template>

<script>
import moment from 'moment';
import EventFormVue from '../components/mytime/EventForm.vue';
import ReportFormVue from '../components/report/ReportForm.vue';
import ConfirmDialogVue from '../components/dialog/ConfirmDialog.vue';
import NotifyVue from '../components/dialog/Notify.vue';
import { mapGetters } from 'vuex';
import apiRepository from '../api/api-repository';

moment.locale('it');

export default {
  components: {
    'event-form': EventFormVue,
    'report-form': ReportFormVue,
    'confirm': ConfirmDialogVue,
    'notify': NotifyVue,
  },
    
  data: ()=> ({
    // proprietà del calendario.
    weekInItaly: [ 1, 2, 3, 4, 5, 6, 0 ], // formato settimana italiana.
    current: moment().format('YYYY-MM-DD'), // giornata corrente.
    intervals: { first: 14, minutes: 30, count: 31, height: 48 }, // intervallo di visualizzazione.
    calendarHeight: null, // altezza del calendario.
    overlapMode: 'column', // modalità di visualizzazione degli eventi sul calendario.
    startDay: null, // giorno di inizio dell'intervallo settimanale.
    endDay: null, // giorno di fine dell'intervallo settimanale.
    events: new Array(),  // lista di attività dell'utente.
    // selezione dell'evento.
    selectedEvent: new Object(), // evento selezionato dal calendario.
    selectedElement: null, // evento nativo selezionato dal calendario.
    selectedOpen: false, // apertura/chiusura del box di visulizzazione dell'evento.
    // gestione del form di creazione/modifica.
    isNewEvent: true,
    eventAsRequest: { 
      id: null, datReport: moment().format('YYYY-MM-DD'), 
      datStart: null, datEnd: null, areaId: null, activityId: null, 
      notes: null, flagSmartWorking: false 
    },
    // gestione del form di generazione del report.
    report: new Object(),
    colors: [ 'cyan', 'green', 'orange', 'red', 'purple', 'blue', 'light-blue', 'pink', 'yellow', 'grey' ],
    areaColors: [ ],
  }),

  computed: {
    ...mapGetters('oidcStore', [ 'oidcIsAuthenticated', 'oidcUser', 'oidcAccessToken' ]),
    ...mapGetters('argoStore', [ 'isRegister', 'isAdministrator', 'user' ]),

    formattedStart(){
      return (this.startDay) ? moment(this.startDay).format('DD/MM/YYYY') : '';
    },

    formattedEnd(){
      return (this.endDay) ? moment(this.endDay).format('DD/MM/YYYY') : '';
    },

    formattedDayOfEvent(){
      if(!this.selectedEvent) return '';
      const date = moment(this.selectedEvent.start).format('dddd, D MMMM YYYY'), 
        start = moment(this.selectedEvent.start).format('HH:mm'), end = moment(this.selectedEvent.end).format('HH:mm');
      return `${date} ⋅ ${start} – ${end}`;
    }
  },

  methods: {
    getEvents({ start, end }){
      this.startDay = start.date; // recupero l'intervallo di inizio (evento del calendario).
      this.endDay = end.date; // recupero l'intervallo di fine (evento del calendario).
      this.init(); // carico la lista degli eventi.
    },

    getToday(){
      this.startDay = moment().isoWeekday(1).format('YYYY-MM-DD'); // resetto l'intervallo di inizio.
      this.endDay = moment().isoWeekday(7).format('YYYY-MM-DD'); // resetto l'intervallo di fine.
      this.current = moment().format('YYYY-MM-DD'); // resetto la data corrente a quella di oggi.
      this.init(); // ricarico la lista degli eventi del calendario.
    },

    viewEvent({ nativeEvent, event }){
      const open = ()=> {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(()=> this.selectedOpen = true, 10);
      };

      if(this.selectedOpen){
        this.selectedOpen = false;
        setTimeout(open, 10);
      } 
      else open();

      nativeEvent.stopPropagation();
    },

    generateReport(){
      this.report = { from: this.startDay, to: this.endDay, areaId: null, activityId: null, userId: null };
      if(this.isAdministrator) this.report.userId = this.user.id;
      this.$refs.refReportForm.open();
    },

    createEvent(){
      this.isNewEvent = true;
      this.eventAsRequest = { 
        id: null, datReport: moment().format('YYYY-MM-DD'), 
        datStart: null, datEnd: null,
        areaId: null, activityId: null, 
        notes: null, flagSmartWorking: false 
      };
      this.$refs.refEventForm.open();
    },

    editEvent(){
      this.isNewEvent = false; const event = this.selectedEvent.origin;
      this.eventAsRequest = { 
        id: event.id, datReport: event.datReport, 
        datStart: event.datStart.split('T')[1], datEnd: event.datEnd.split('T')[1], 
        areaId: event.area.id, activityId: event.activity.id, 
        notes: event.notes, flagSmartWorking: event.flagSmartWorking 
      };
      this.$refs.refEventForm.open();
    },

    askRemoveEvent(){
      const title = 'Conferma cancellazione', 
        message = `Sei sicuro di voler cancellare l'attività di ${this.formattedDayOfEvent}? L'operazione è irreversibile.`;
      this.$refs.refConfirm.confirm(title, message);
    },

    async removeEvent(answer, item){
      if(!answer) return; // richiesta di cancellazione annullata.
      // richiesta di cancellazione confermata.
      let event = item.origin; // recupero l'evento originale wrappato in quello del calendario.
      // procedo con la cancellazione dell'evento.
      try{
        let res = await apiRepository.events().deleteById(event.id); // richiamo l'api di cancellazione del servizio.
        this.notify(res); // notifico la riuscita dell'operazione.
      }
      catch(e){
        console.error('exception:', e); // loggo l'errore riscontrato.
        this.notify(e); // notifico l'errore riscontrato.
      }
    },

    notify(res){
      this.init();
      if(res.success) this.$refs.refNotify.notify((res.success) ? 'success' : 'error', res.message); // notifico la riuscita dell'operazione.
      else this.$refs.refNotify.notify('error', res.message); // notifico l'errore riscontrato nell'operazione.
    },

    async init(){
      // definisco la richiesta con l'intervallo selezionato.
      let req = { startDay: this.startDay, endDay: this.endDay };

      try{
        // recupero gli eventi del range settimanale imposto dal calendario.
        let res = await apiRepository.events().findByWeek(req); // attendo la risposta dalla api.
        let events = new Array(); // inizializzo la lista degli eventi.
        // scorro i risultati per creare la lista degli eventi.
        res.data.forEach((x)=> {
          events.push({ 
            name: x.activity.description, 
            start: x.datStart.replace('T', ' '), end: x.datEnd.replace('T', ' '), details: x.notes, 
            flagSmartWorking: x.flagSmartWorking, area: x.area.description, areaId: x.area.id,
            editable: x.editable, removable: x.removable, origin: x 
          });
        });
        // assegno la lista degli eventi alla lista associata al calendario.
        this.events = events; // aggiorno la lista degli eventi.
      }
      catch(e){
        console.error('exception:', e); // loggo l'errore riscontrato.
        this.$refs.refNotify.notify('error', e.message) // notifico l'errore riscontrato.
      }
    },

    getEventColor(event){
      const color = this.areaColors.find((x)=> x.id === event.areaId);
      return (color) ? color.color : 'grey';
    },

    async setAreaColors(){
      let areaColors = [ ];
      const res = await apiRepository.area().findAll(), areas = res.data;

      for(let i = 0; i < areas.length; i++){
        const x = { id: areas[i].id, color: (i < this.colors.length) ? this.colors[i] : this.colors[(i - this.colors.length - 1)] };
        areaColors.push(x);
      }

      this.areaColors = areaColors;
    },

    adaptCalendar(){
      const yHeader = document.getElementById('tr-header').style.height.replace('px', '');
      const yToolbar = document.getElementById('calendar-toolbar').style.height.replace('px', '');
      this.calendarHeight = window.innerHeight - yHeader - yToolbar - 1;
    }
  },

  mounted(){
    this.adaptCalendar();
  },

  created(){
    this.setAreaColors();
  }
}
</script>
